import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Tooltip,
  Box,
} from "@mui/material";
import { FolderType } from "../../types/interfaces/filesStorage";

interface FolderTypeOption {
  value: FolderType;
  label: string;
}

const FOLDER_TYPE_OPTIONS: FolderTypeOption[] = [
  { value: "all", label: "All Folders" },
  { value: "integration", label: "Integration Folders" },
  { value: "migration", label: "Migration Folders" },
];

interface FolderTypeFilterProps {
  value: FolderType;
  onChange: (value: FolderType) => void;
  disabled?: boolean;
  disabledTooltip?: string;
}

const FolderTypeFilter: React.FC<FolderTypeFilterProps> = ({
  value,
  onChange,
  disabled = false,
  disabledTooltip = "Filter only available at root level",
}) => {
  const handleChange = (event: SelectChangeEvent<FolderType>) => {
    onChange(event.target.value as FolderType);
  };

  const selectComponent = (
    <FormControl variant="outlined" size="small" disabled={disabled}>
      <Select
        value={value}
        onChange={handleChange}
        sx={{
          minWidth: 180,
          height: "40px",
          fontFamily: "Century Gothic, sans-serif",
          color: disabled ? "text.disabled" : "rgb(31,93,107)",
          ".MuiSelect-icon": { color: disabled ? "text.disabled" : "rgb(31,93,107)" },
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: disabled ? "rgba(0, 0, 0, 0.12)" : "rgba(0, 0, 0, 0.23)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: disabled ? "rgba(0, 0, 0, 0.12)" : "rgb(31,93,107)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgb(31,93,107)",
          },
        }}
      >
        {FOLDER_TYPE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  if (disabled) {
    return (
      <Tooltip title={disabledTooltip} arrow placement="top">
        <Box component="span" sx={{ display: "inline-flex" }}>
          {selectComponent}
        </Box>
      </Tooltip>
    );
  }

  return selectComponent;
};

export default FolderTypeFilter;
